import { safeParse } from '../../utils/helpers';
import * as type from '../actions/types';

const initialState = {
  userInfo: {
    id: sessionStorage?.getItem('userId') || null,
  },
  userFetching: true,
  userError: false,
  userErrorMessage: '',
  loggingOut: false,
  redirectUrl: null, // When the user is logged out, this is the redirect url
  isAdmin: false, // If the user is an admin. This is returned from the linked venues fetch
  obeeUserLinkedVenues: {
    data: [],
    success: false,
    loading: false,
    error: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_USER_PENDING:
      return {
        ...state,
        ...initialState,
        userFetching: true,
      };

    case type.FETCH_USER_SUCCESS: {
      const parsedRestaurants = action.payload?.restaurants?.map((restaurant) =>
        JSON.parse(restaurant),
      );

      return {
        ...state,
        userFetching: false,
        userInfo: {
          ...action.payload,
          restaurants: parsedRestaurants,
        },
      };
    }

    case type.FETCH_USER_FAILURE:
      return {
        ...state,
        userFetching: false,
        userError: true,
        userErrorMessage: action.payload,
      };

    case type.SET_LOGOUT_PENDING:
      return {
        ...state,
        loggingOut: true,
      };

    case type.CLEAR_LOGIN_ERROR:
      return {
        ...state,
        userError: false,
        userErrorMessage: '',
      };

    case type.FETCH_LINKED_VENUES_SUCCESS:
      return {
        ...state,
        obeeUserLinkedVenues: {
          data: safeParse(action.payload),
          success: true,
          loading: false,
          error: null,
        },
        isAdmin: safeParse(action.payload)?.loggedInUser?.obee_staff === '1' ?? false,
      };

    default:
      return state;
  }
};
